import SubmitRepair from "./submitRepair.gql";
import QueryList from "./queryList.gql";
import {queryHdl, mutationHdl} from "../graphqlHdr";
import ChangeStatus from "./changeStatus.gql";

export default {
  // 报修列表
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, variables),
  // 提交报修
  submitRepair: (vueSelf, variables) => mutationHdl.call(vueSelf, SubmitRepair, variables),
  // 改变报修状态
  changeStatus: (vueSelf, variables) => mutationHdl.call(vueSelf, ChangeStatus, variables),
}
